exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@font-face {\n\tfont-weight: normal;\n\tfont-style: normal;\n\tfont-family: 'Roboto Slab';\n\tsrc: local('Roboto Slab Regular'),\n\t\t local('Roboto-Slab-Regular'),\n\t\t url(" + require("./fonts/roboto-slab-regular.ttf") + ");\n}\n\n@font-face {\n\tfont-weight: 100;\n\tfont-style: normal;\n\tfont-family: 'Roboto Slab';\n\tsrc: local('Roboto Slab Thin'),\n\t\t local('Roboto-Slab-Thin'),\n\t\t url(" + require("./fonts/roboto-slab-thin.ttf") + ");\n}\n\nhtml,\nbody {\n    margin: 0;\n    padding: 0;\n\t height: 100%;\n\t width: 100%;\n    background: #20292e;\n    position: relative;\n    overflow: hidden;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/components/main/main.css
// module id = ./node_modules/css-loader/index.js!./src/components/main/main.css
// module chunks = index